import personnel from './personnel'; //人员主数据列表
import cooperation from './cooperation'; // 合作伙伴主数据
import outsidePrice from './outsidePrice'; // 外部价格主数据
import supplyChain from './supplyChain'; // 外部价格主数据
import bank from './bank'; // 银行主数据
import companyZhLocale from './company'; //组织主数据-公司
import goods from './goods'; //商品主数据列表
import account from './account'; //科目
export default {
  ...personnel,
  ...cooperation,
  ...outsidePrice,
  ...supplyChain,
  ...bank,
  ...companyZhLocale,
  ...goods,
  ...account,
};
